<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            @searchResource="searchResource" 
            @create="dialog = true"
          />
        </v-col>
        <v-col cols="12">
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0">
                <v-col cols="2" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  {{i18n.name}}
                </v-col>
                <v-col cols="2" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-left`">
                  {{i18n.agent}}
                </v-col>
                <v-col cols="1" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.sent}}
                </v-col>
                <v-col cols="1" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.opened}}
                </v-col>
                <v-col cols="1" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.clicked}}
                </v-col>
                <v-col cols="1" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.status}}
                </v-col>
                <v-col cols="3" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold text-center`">
                  {{i18n.viewIconTooltip}}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" CustomPageActions>
          <v-card class="px-3" :loading="loading">
            <v-row class="pa-0">
              <v-col cols="12" md="2">
                <v-btn block text color="success" :loading="loading"  @click="sendNewSpecialCampaign()"
                  :class="`${arabic?'arFont':'enFont'}`"
                >send to old</v-btn>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn block text color="success" :loading="loading" @click="sendNewSpecialCampaign(true)"
                  :class="`${arabic?'arFont':'enFont'}`"
                >send to new</v-btn>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn block text color="success" :loading="loading" v-if="aws.available" @click="getAWS()"
                  :class="`${arabic?'arFont':'enFont'}`"
                >
                  
                  <v-icon left>sync</v-icon>
                  {{aws.available}}
                  <v-avatar
                    size="12"
                    class="mx-2"
                    :color="aws.enabled ? 'green' : 'red'"
                  >
                    <v-icon size="10" color="white" v-if="aws.enabled">done</v-icon>
                    <v-icon size="10" color="white" v-else>close</v-icon>
                  </v-avatar>
                </v-btn>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn block text color="error" :loading="loading" @click="resetTracking()"
                  :class="`${arabic?'arFont':'enFont'}`"
                >
                  reset tracking
                </v-btn>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn block text color="error" :loading="loading" @click="resetSystem()"
                  :class="`${arabic?'arFont':'enFont'}`"
                >
                  reset system
                </v-btn>
              </v-col>
              <v-col cols="12" md="2">
                <v-btn block color="error" :loading="loading" @click="emergency()"
                  :class="`${arabic?'arFont':'enFont'}`"
                >
                  emergency
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-expansion-panels focusable>
                  <v-expansion-panel style="cursor:pointer;">
                  <v-expansion-panel-header>
                    <span style="font-size:12px;">STATS</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <line-chart :height="200" ref="chart" :chartdata="data" :options="options"/>
                  </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
            <v-row row justify-center>
              <v-dialog v-model="newDialog" persistent max-width="1000">
                <v-card>
                  <v-card-title class="headline">New Special Campaign</v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="4" class="py-0">
                        <v-autocomplete
                          :items="getExtraItems('companies')"
                          v-model="campaign.country"
                          :label="i18n['company']"
                          @change="getNewCount()"
                          outlined
                          dense
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4" class="py-0">
                        <v-autocomplete
                          :items="getExtraItems('programs')"
                          v-model="campaign.program"
                          :label="i18n['programs']"
                          outlined
                          @change="getNewCount()"
                          dense
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="4" class="py-0">
                        <v-autocomplete
                          :items="getExtraItems('templates')"
                          v-model="campaign.template"
                          :label="i18n['templates']"
                          outlined
                          dense
                          item-value="id"
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="12" class="py-0">
                        <v-text-field
                          :label="i18n['subject']"
                          outlined
                          dense
                          v-model="campaign.subject"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4" class="py-0" v-if="!newSpecialCampaign">
                        <v-text-field
                          :label="i18n['limit']"
                          outlined
                          dense
                          v-model="campaign.limit"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4" class="py-0" v-if="newSpecialCampaign">
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="campaign.from"
                              label="From Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              outlined
                          
                              dense
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            @change="getNewCount()"
                            v-model="campaign.from"
                            @input="menu = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="4" class="py-0" v-if="newSpecialCampaign">
                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="campaign.to"
                              label="To Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="campaign.to"
                            @change="getNewCount()"
                            @input="menu2 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="4" class="py-0" v-if="newSpecialCampaign">
                        TOTAL: {{newCount}}
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click.native="newDialog = false">cancel</v-btn>
                    <v-btn color="success" text @click.native="sendNewCampaing()">send</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 mb-2 elevation-2 px-2 align-center py-3" 
                v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
                <v-col cols="6" md="3" :class="`${arabic?'arFont':'enFont'} pa-0 font-weight-bold`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{r.name}}</span>
                    </template>
                    <div class="text-center">
                      <div :class="`${arabic?'arFont':'enFont'}`">{{r.from_name}}</div>
                      <div :class="`${arabic?'arFont':'enFont'}`">{{r.from_email}}</div>
                      <div :class="`${arabic?'arFont':'enFont'}`">{{r.reply_to}}</div>
                    </div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="2" :class="`${arabic?'arFont':'enFont'} pa-0`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{r.username}}</span>
                    </template>
                    <div :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.useremail}}</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{r.count}}
                      </span>
                    </template>
                    <div :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.count}} {{i18n.sent}}</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{r.opens}}
                        <span style="font-size:8px;">({{r.open_percentage}}%)</span>
                      </span>
                    </template>
                    <div :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.opens}} ({{r.open_percentage}}%) {{i18n.opened}}</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{r.clicks}}
                        <span style="font-size:8px;">({{r.click_percentage}}%)</span>
                      </span>
                    </template>
                    <div :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.clicks}} ({{r.click_percentage}}%) {{i18n.clicked}}</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-progress-circular 
                          indeterminate 
                          v-if="r.active_sending"
                          size="20"
                          color="primary"
                          :class="`${arabic?'arFont':'enFont'}`"
                          style="font-size:8px;"
                        >{{r.sending_progress}}%</v-progress-circular>
                        <v-icon v-if="r.in_draft">stop_circle</v-icon>
                        <v-icon v-if="r.sent" color="success">verified</v-icon>
                      </span>
                    </template>
                    <div :class="`${arabic?'arFont':'enFont'}`">{{i18n.lastUpdated}} {{getFormat(r.updated_at)}}</div>
                    <div :class="`${arabic?'arFont':'enFont'}`" v-if="r.active_sending">{{i18n.sendingActive}}</div>
                    <div :class="`${arabic?'arFont':'enFont'}`" v-if="r.active_sending">{{r.sent_count}} / {{r.count}}</div>
                    <div :class="`${arabic?'arFont':'enFont'}`" v-if="r.in_draft">{{i18n.inDraft}}</div>
                    <div :class="`${arabic?'arFont':'enFont'}`" v-if="r.sent">{{i18n.alreadySent}} {{r.sent_count}}</div>
                    <div :class="`${arabic?'arFont':'enFont'}`" v-if="r.sent">Delivered {{r.delivered}}</div>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="error" 
                        :disabled="r.sent || r.active_sending"
                        icon x-small @click.stop="skip(r)">
                          <v-icon>verified</v-icon>
                      </v-btn>
                    </template>
                    <span :class="`${arabic?'arFont':''} pa-0`">
                      Skip Campaign
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="error" 
                        :disabled="!r.active_sending"
                        icon x-small @click.stop="stop(r)">
                          <v-icon>cancel_schedule_send</v-icon>
                      </v-btn>
                    </template>
                    <span :class="`${arabic?'arFont':''} pa-0`">
                      Stop Campaign
                    </span>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" md="1" :class="`${arabic?'arFont':'enFont'} pa-0 adminSwitch text-center`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="error" 
                        icon x-small @click.stop="deleteCampaign(r)">
                          <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                    <span :class="`${arabic?'arFont':''} pa-0`">
                      Delete Campaign
                    </span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" NewEditDeleteDialog>
          <v-dialog v-model="dialog" persistent max-width="1000">
            <v-card :loading="loading">
              <v-card-title :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;">
                <div>{{ i18n[resourceSettings.resourceName]  + ' | ' }}<span class="font-weight-light">{{i18n.add}}</span></div>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4" class="py-0" v-for="(field, k) in resourceKeys" :key="'key-' + k">
                    <v-text-field
                      :label="i18n[field.label]"
                      :name="i18n[field.label]"
                      outlined
                      v-if="field.type == 'text'"
                      :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
                      dense
                      :class="`${arabic?'arFont':'enFont'}`"
                      v-model="newResource[field.name]"
                    ></v-text-field>
                    <v-autocomplete
                      :items="getItems(field.items)"
                      v-model="newResource[field.name]"
                      :label="i18n[field.label]"
                      :name="i18n[field.label]"
                      :rules="[ field.required ? rules.required : false]"
                      v-if="field.type == 'select'"
                      outlined
                      dense
                      item-text="name"
                      item-value="id"
                      :class="`${arabic?'arFont':'enFont'}`"

                    >
                      <!-- <template v-slot:selection="{ attr, on, item, selected }">
                        <span
                          v-bind="attr"
                          :input-value="selected"
                          v-on="on"
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                          {{i18n[item]}}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <span
                          :class="`${arabic?'arFont':'enFont'}`"
                        >
                          {{i18n[item]}}
                        </span>
                      </template> -->
                    </v-autocomplete>
                    <v-switch 
                      v-if="field.type == 'switch'"
                      :class="`${arabic?'arFont':'enFont'}`" 
                      :label="i18n[field.label]" 
                      :name="i18n[field.label]" 
                      v-model="newResource[field.name]"
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click.native="dialog = false" :class="`${arabic?'arFont':'enFont'}`">{{i18n.cancelBtn}}</v-btn>
                <v-btn 
                  color="success" 
                  v-if="!newResource.id"
                  :disabled="!validate(newResource)"
                  text @click.native="postResource(newResource)" 
                  :class="`${arabic?'arFont':'enFont'}`"
                >{{i18n.submitBtn}}</v-btn>
                <v-btn 
                    color="success" 
                    v-if="newResource.id"
                    :disabled="!validate(newResource)"
                    text @click.native="updateResource(newResource)" 
                    :class="`${arabic?'arFont':'enFont'}`"
                  >{{i18n.updateBtn}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};
import LineChart from '@/LineChart.js'

export default {
  components: { Search, Paging, LineChart },
  data() {
    return {
      loading:false,
      dialog:false,
      newDialog:false,
      newSpecialCampaign:false,
      menu:false,
      menu2:false,
      campaign:{},
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        {name: 'name', label:'name', type:'text', required:true },
        {name: 'from_name', label:'fromName', type:'text', required:true },
        {name: 'from_email', label:'fromEmail', type:'text', required:true, email:true },
        {name: 'reply_to', label:'replyTo', type:'text', required:true, email:true },
        {name: 'subject', label:'subject', type:'text', required:true },
        {name: 'template', label:'template', type:'select', items:'templates', required:false },
        {name: 'list', label:'list', type:'select', items:'lists', required:false },
      ],
      resourceSettings:{
        resourceName:null,
        search:true,
        create:true,
        pagination:true,
      },
      extraFields:[
        { name: 'company', label:'company', type:'select', items:'companies', source:'local', data:['tunisia', 'morocco', 'egypt', 'iraq', 'palestine', 'algeria', 'jordan', 'erbil', 'libya'], required:true },
        {name: 'program', label:'program', type:'select', items:'programs', data:['ausbildung', 'jobs', 'nurses', 'engineers', 'students', 'doctors', 'tech'], source:'local',  required: true },
        {name: 'templates', label:'templates', type:'select', items:'templates', data:[], source:'db', required:true },
      ],
      newResource:{},
      editing:false,
      deleting:false,
      templates:[],
      lists:[],
      newCount:0,
      aws:{},
      data:{
        labels: [],
        datasets: [{
          label: 'Deliveries',
          data: [],
          fill: false,
          borderColor: 'rgb(75, 192, 192)',
          tension: 0.1
        }]
      },
      options: {
          scales: {
            yAxes: [{
              stacked: true
            }]
        }
      },
      chartLoad:false,
    }
  },
  
  methods: {
    async getAWS(){
      this.loading = true
      this.aws = await axios.get(`${this.api}/aws`).then(x=>x.data)
      console.log(this.aws)
      let s = this.aws.stats
      .filter(x=> new Date(x.Timestamp).getTime() - new Date().getTime() < 24 * 60 * 60 * 1000 )
      .sort((a, b)=> new Date(b.Timestamp).getTime() - new Date(a.Timestamp).getTime()).slice(0, 30).reverse()
      for (let i = 0; i < 30; i++) {
        const x = s[i];
        this.data.datasets[0].data.push(parseInt(x.DeliveryAttempts))
        this.data.labels.push(`${x.Timestamp.split('T')[0]} | ${x.Timestamp.split('T')[1].split('+')[0]}`)
      }
      console.log(this.data)
      this.chartLoad = true
      console.log(this.$refs)
      this.$refs.chart.renderChart(this.data, this.options)
      this.loading = false
    },
    async getNewCount(){
      console.log(this.campaign)
      if(!this.campaign.country) {
        this.newCount = 0
        return true
      }
      if(!this.campaign.program) {
        this.newCount = 0
        return true
      }
      if(!this.campaign.from) {
        this.newCount = 0
        return true
      }
      if(!this.campaign.to) {
        this.newCount = 0
        return true
      }
      let a = await axios.post(`${this.api}/new-leads/counter-date`, this.campaign, {headers}).then(x=>x.data)
      console.log(a)
      this.newCount = a.total
    },
    sendNewSpecialCampaign(newType){
      this.newDialog = true
      this.newSpecialCampaign = newType
    },
    async sendNewCampaing() {
      return new Promise(async (resolve, reject) => {
        console.log(this.campaign)
        this.campaign.name = `AUTO | ${this.campaign.country} | ${this.campaign.program} | ${this.newSpecialCampaign ? 'NEW' : 'OLD' } | `
        + `${this.newSpecialCampaign ? this.campaign.from + ' - ' + this.campaign.to : this.campaign.limit  }`
        this.campaign.type = this.newSpecialCampaign ? 'new' : 'old'
        let a = await this.$store.dispatch('newCampaign', this.campaign)
        console.log(a)
        
        this.newDialog = false
        this.newSpecialCampaign = false
        resolve(a)
      })
    },
    async skip(r) {
      this.loading = true
      await axios.get(`https://aramcogermany.com/back/public/api/v1/skip-campaign/${r.id}`).then(x=>x.data)
      this.loadResource()
    },
    async stop(r) {
      this.loading = true
      await axios.get(`https://aramcogermany.com/back/public/api/v1/stop-campaign/${r.id}`).then(x=>x.data)
      this.loadResource()
    },
    async deleteCampaign(r) {
      this.loading = true
      await axios.get(`https://aramcogermany.com/back/public/api/v1/delete-campaign/${r.id}`).then(x=>x.data)
      this.loadResource()
    },
    async resetTracking() {
      this.loading = true
      await axios.get(`https://aramcogermany.com/back/public/api/v1/reset-tracking`).then(x=>x.data)
      this.loadResource()
    },
    async resetSystem() {
      this.loading = true
      await axios.get(`https://aramcogermany.com/back/public/api/v1/reset-system`).then(x=>x.data)
      this.loadResource()
    },
    async emergency() {
      this.loading = true
      await axios.get(`https://aramcogermany.com/back/public/api/v1/emergency`).then(x=>x.data)
      this.loadResource()
    },
    async forceCampaign(a){
      var popup = window.open(`https://aramcogermany.com/back/public/api/v1/q-emails/${a.list_meta}`, "myWindow", "width=100, height=100, location=no, left=4000, top=4000");
      popup.blur();
      window.focus();
      setTimeout(x=>{
        popup.close();
      }, 10000)
    },
    async loadItems(){
      return new Promise(async (res, rej)=>{
        let ks = this.extraFields.filter(x=>x.type=='select' && x.source == 'db');
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = await this.$store.dispatch('loadAllResource', {resource:`/${f.items}`})
            let maps = t.map(x=>{
              let t = x.name?x.name:x.company?x.company:x.country?x.country:x.program?x.program:null
              return{...x, text:t, [`${f.items}_id`]:x.id}
            })
            f.data = maps
          }
          res(true)
        })()
      })
    },
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.required}`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.valid_email}`, 'error')
        }
      })
      return v
    },
    getItems(items) {
      return this[items]
    },
    getExtraItems(items){
      return this.extraFields.filter(x=>x.items == items)[0].data
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        }
        this.loading = false
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}`})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        this.loading = false
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:this.$route.path + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        await this.$store.dispatch('postResource', {resource:this.$route.path + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    }
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    await this.loadItems()
    this.setResourceName()
    this.getAWS()
    await this.loadResource()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>